module.exports = __webpack_public_path__ + "static/media/corporate-photo.84a53e05.png";